// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1oIG0","alertIcon":"ConfirmModal_alertIcon__1HnNC"};